<section
  class="rounded-lg p-4"
  [ngClass]="
    transportFormService.roadStops.invalid
      ? 'border border-red-500 bg-red-50'
      : 'bg-primary-50'
  "
>
  <div class="mb-4 flex flex-col gap-2">
    <h4 class="text-primary-900">
      {{ "prestation.addressForm.title" | transloco }}
    </h4>

    <!-- Itinerary summary: prominent link to the full route + total distance -->

    @for (
      roadStop of transportFormService.roadStopsControls;
      track roadStop;
      let i = $index;
      let last = $last
    ) {
      <div
        class="flex flex-row items-start gap-2"
        [class.opacity-50]="draggedIndex === i"
        (dragover)="onDragOver($event)"
        (drop)="onDrop($event, i)"
        (dragend)="onDragEnd()"
      >
        <!-- Drag handle (only the handle is draggable so the autocomplete stays usable) -->
        <div
          class="cursor-move pt-3 text-gray-400 hover:text-gray-600"
          draggable="true"
          (dragstart)="onDragStart($event, i)"
          data-testid="roadstop-drag-handle"
        >
          <i class="pi pi-bars text-lg"></i>
        </div>

        <div class="flex flex-1 flex-col">
          <div class="flex flex-row">
            <app-select-address
              [inputId]="'selectAddress' + i"
              [ariaLabel]="'calculator.label.' + labelFor(i, last) | transloco"
              [placeholder]="placeholderFor(i, last)"
              class="flex-1"
              [formGroup]="roadStop"
            />

            @if (i > 0 && !last) {
              <div class="flex shrink-0 items-start pt-3">
                <button
                  (click)="transportFormService.removeWaypoint(i)"
                  data-testid="remove-roadstop-button"
                >
                  <i
                    class="pi pi-trash ml-2 !text-gray-500 hover:scale-105 hover:cursor-pointer hover:!text-red-700"
                  ></i>
                </button>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Between two stops: leg distance (left, in the drag gutter) +
           insert-a-waypoint (right, aligned with the delete buttons) -->
      @if (!last) {
        <div class="flex items-center gap-2 py-1 text-paragraph-xs-reg">
          @if (legDistanceAfter(i) !== null) {
            <span class="flex items-center gap-1 text-greyscale-600">
              <span class="flex w-5 justify-center text-primary-400">
                <i class="pi pi-arrow-down"></i>
              </span>
              {{ legDistanceAfter(i) | number: "1.0-1" }} km
            </span>
          }
          <button
            type="button"
            class="ml-auto flex items-center gap-1 text-primary-500 hover:text-primary-700"
            (click)="transportFormService.insertWaypointAt(i + 1)"
            data-testid="add-roadstop-button"
          >
            {{ "calculator.addWaypoint" | transloco }}
            <i class="pi pi-plus-circle"></i>
          </button>
        </div>
      }
    }
  </div>
  <app-error [control]="transportFormService.roadStops" />
  @if (details(); as resolved) {
    <div class="flex flex-col gap-1">
      <a
        [href]="resolved.mapsItineraryUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-primary-500 px-3 py-2 text-paragraph-s-reg font-medium text-white transition-colors hover:bg-primary-600"
      >
        <i class="pi pi-map-marker"></i>
        {{ "prestation.itinerary.viewFullItinerary" | transloco }}
      </a>
      @if (totalDistance() !== null) {
        <span class="text-paragraph-xs-reg text-greyscale-600">
          {{ "prestation.itinerary.totalDistance" | transloco }} :
          <span class="font-semibold text-primary-900"
            >{{ totalDistance() | number: "1.0-0" }} km</span
          >
        </span>
      }
      @if (resolved.calculationMode === "coordonates") {
        <span
          class="flex items-start gap-1 text-paragraph-xs-reg text-warning-700"
        >
          <i class="pi pi-exclamation-triangle mt-0.5"></i>
          {{ "prestation.itinerary.straightLineNote" | transloco }}
        </span>
      }
    </div>
  } @else if (loading()) {
    <div
      class="flex items-center gap-2 text-paragraph-xs-reg text-greyscale-600"
    >
      <i class="pi pi-spinner pi-spin"></i>
      {{ "prestation.itinerary.computing" | transloco }}
    </div>
  }
</section>
